/**
 * Chave estável para identificar uma dívida na listagem (api + id).
 * Usada pelo sync, Prime e caches de lote — manter uma única implementação aqui.
 */
export function calcularChaveDivida(api: string, id: number): string {
  return `${api}-${id}`;
}
